import correct from '@/assets/img/documents/cost-estimate-after.jpg';
import wrong from '@/assets/img/documents/cost-estimate-after-wrong.jpg';
import Card from '@/components/Card';
import ChatMessage from '@/components/ChatMessage';
import { Uploader } from '@/components/ui/Uploader/Uploader';
import { ATTACHMENT_TYPES } from '@/consts';

import { useLingui } from '@lingui/react';

export const COST_ESTIMATE_AFTER_ACCIDENT_NAME = 'cost_estimate_after_accident';

const CostEstimateAfterAccident = ({
  required = false,
  message = false,
}: {
  required?: boolean;
  message?: boolean;
}) => {
  const { i18n } = useLingui();

  const instructionProps = {
    title: i18n.t('Jak poprawnie dodać arkusz wraku?'),
    steps: [
      i18n.t('Upewnij się, że wszystkie dane pojazdu są widoczne.'),
      i18n.t('Sprawdź, czy załączasz wszystkie strony decyzji.'),
      i18n.t('Jeśli przesyłasz zdjęcia – sprawdź, czy dokument jest czytelny.'),
      i18n.t('Jeśli plik jest zabezpieczony – dołącz hasło.'),
    ],
    correctImg: correct,
    wrongImg: wrong,
  };

  return (
    <div>
      <Card>
        <Uploader
          title={i18n.t('Arkusz wraku lub wycena z aukcji')}
          instructionProps={instructionProps}
          inputFieldName={COST_ESTIMATE_AFTER_ACCIDENT_NAME}
          required={required}
          attachmentTypeId={
            ATTACHMENT_TYPES.ARKUSZ_WYCENY_POJAZDU_PO_SZKODZIE_WRAKU
          }
        />
      </Card>
      {message && (
        <ChatMessage
          variant="secondary"
          className="mt-3 lg:mt-5"
          description={
            'Uwaga ważna informacja! By umożliwić rzeczoznawcy analizę Twojej szkody koniecznie prześlij arkusz wyceny wraku lub wycenę z aukcji, którą przygotował i przesłał Ci ubezpieczyciel.'
          }
        />
      )}
    </div>
  );
};

export default CostEstimateAfterAccident;
